module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-swipe', {
    staticClass: "header-swiper",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "FD2840"
    }
  }, _vm._l((_vm.detail.pics_url), function(item) {
    return _c('van-swipe-item', {
      key: item.id
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item),
        expression: "item"
      }],
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "flex-between"
  }, [_c('div', {
    staticClass: "flex-bleft"
  }, [_c('span', {
    staticClass: "tuan-text"
  }, [_vm._v("团购价")]), _vm._v(" "), _c('span', {
    staticClass: "tuan-price"
  }, [_vm._v("¥" + _vm._s(_vm.detail.price))]), _vm._v(" "), _c('span', {
    staticClass: "thr-price"
  }, [_vm._v("¥" + _vm._s(_vm.detail.goods_price))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-bright"
  }, [(_vm.detail.status == 1) ? _c('div', {
    staticClass: "djs-text"
  }, [_vm._v("距离结束还有")]) : (_vm.detail.status == 3) ? _c('div', {
    staticClass: "djs-text"
  }, [_vm._v("距离开始还有")]) : (_vm.detail.status == 4) ? _c('div', {
    staticClass: "djs-text"
  }, [_vm._v("已过期")]) : (_vm.detail.status == 2) ? _c('div', {
    staticClass: "djs-text"
  }, [_vm._v("已下架")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "djs-num"
  }, [_c('van-count-down', {
    attrs: {
      "time": (_vm.detail.last_time + 1) * 1000
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(timeData) {
        return [_c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.days))]), _vm._v("天\n            "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.hours))]), _vm._v(" "), _c('span', {
          staticClass: "sign"
        }, [_vm._v(":")]), _vm._v(" "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.minutes))]), _vm._v(" "), _c('span', {
          staticClass: "sign"
        }, [_vm._v(":")]), _vm._v(" "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.seconds))])]
      }
    }])
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "good-name"
  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('div', {
    staticClass: "row-yf gray"
  }, [_c('div', {
    staticClass: "row-left"
  }, [_vm._v("已售 " + _vm._s(_vm.detail.sold_count + _vm.detail.sold_show_count))]), _vm._v(" "), _c('div', {
    staticClass: "row-right-yf"
  }, [_vm._v("\n      运费 ¥\n      "), (_vm.detail.express_price[0] == _vm.detail.express_price[1]) ? _c('span', [_vm._v(_vm._s(_vm.detail.express_price[0]))]) : _c('span', [_vm._v(_vm._s(_vm.detail.express_price[0] + '-' + _vm.detail.express_price[1]))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-between dian-raw",
    on: {
      "click": function($event) {
        return _vm.goBaseDetail(_vm.detail.business_id)
      }
    }
  }, [_c('div', {
    staticClass: "dian-left"
  }, [_c('img', {
    attrs: {
      "src": _vm.detail.business_pic_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shop-text"
  }, [_c('div', {
    staticClass: "shop-name"
  }, [_vm._v(_vm._s(_vm.detail.business_name))]), _vm._v(" "), _c('div', {
    staticClass: "shop-det gray"
  }, [_vm._v(_vm._s(_vm.detail.business_desc))])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row-list app-border-top"
  }, _vm._l((_vm.detail.extra_data), function(item, index) {
    return _c('div', {
      staticClass: "app-border-bottom flex-between row-one"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.value))])])
  }), 0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.tuan_order_list.length > 0 && _vm.detail.show_info == 1) ? _c('div', {
    staticClass: "tuan-rule-box border-top"
  }, [_c('div', {
    staticClass: "flex-between tuan-rule-join"
  }, [_c('div', {
    staticClass: "tuan-rule-text"
  }, [_vm._v("有" + _vm._s(_vm.tuan_order_list.length) + "人正在开团，可直接参与")])]), _vm._v(" "), _vm._l((_vm.tuan_order_list), function(item, index) {
    return _c('div', {
      staticClass: "tuan-user flex-between",
      on: {
        "click": function($event) {
          return _vm.gotuanShare(item.order_id)
        }
      }
    }, [_c('div', {
      staticClass: "tuan-user-left"
    }, [_c('img', {
      attrs: {
        "src": item.user_head,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tuan-user-name"
    }, [_vm._v(_vm._s(item.user_name))])]), _vm._v(" "), _c('div', {
      staticClass: "tuan-user-right"
    }, [_c('div', {
      staticClass: "tuan-time-box"
    }, [_c('div', {
      staticClass: "tuan-time-tip"
    }, [_vm._v("\n            还差\n            "), _c('span', [_vm._v(_vm._s(item.last_member_count))]), _vm._v("人成团\n          ")]), _vm._v(" "), _c('van-count-down', {
      attrs: {
        "time": (item.last_time + 1) * 1000,
        "format": "剩余DD天 HH : mm : ss"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "join-tuan"
    }, [_vm._v("去参团")])])])
  })], 2) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "tuan-rule-box border-top"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "detail-img",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-home",
    on: {
      "click": _vm.goHome
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "home-o"
    }
  }), _vm._v(" "), _c('p', [_vm._v("首页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-kf",
    on: {
      "click": _vm.goMine
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/newImg/gMy.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("我的")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-one",
    on: {
      "click": _vm.goodsSkuSelect
    }
  }, [_c('p', {
    staticClass: "footer-one-pri"
  }, [_vm._v("¥" + _vm._s(_vm.detail.goods_price))]), _vm._v(" "), _c('p', [_vm._v("单独购买")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-tuan",
    on: {
      "click": _vm.skuSelect
    }
  }, [_c('p', {
    staticClass: "footer-tuna-pri"
  }, [_vm._v("¥" + _vm._s(_vm.detail.price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.detail.complete_count) + "人成团")])])]), _vm._v(" "), _c('div', {
    staticClass: "sku-container"
  }, [_c('van-sku', {
    attrs: {
      "sku": _vm.skuData.goods_sku,
      "goods": _vm.skuData.goods,
      "goods-id": _vm.skuData.goods_id,
      "hide-stock": _vm.skuData.hide_stock,
      "close-on-click-overlay": _vm.closeOnClickOverlay,
      "message-config": _vm.messageConfig
    },
    on: {
      "buy-clicked": _vm.toGoodsBuy
    },
    scopedSlots: _vm._u([{
      key: "sku-actions",
      fn: function(props) {
        return [_c('div', {
          staticClass: "van-sku-actions"
        }, [_c('van-button', {
          attrs: {
            "square": "",
            "size": "large",
            "type": "warning"
          }
        }, [_vm._v("积分兑换")]), _vm._v(" "), _c('van-button', {
          attrs: {
            "square": "",
            "size": "large",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return props.skuEventBus.$emit('sku:buy')
            }
          }
        }, [_vm._v("立即购买")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showGoodsSkuPicker),
      callback: function($$v) {
        _vm.showGoodsSkuPicker = $$v
      },
      expression: "showGoodsSkuPicker"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sku-container"
  }, [_c('van-sku', {
    attrs: {
      "sku": _vm.skuData.sku,
      "goods": _vm.skuData.goods,
      "goods-id": _vm.skuData.goods_id,
      "hide-stock": _vm.skuData.hide_stock,
      "close-on-click-overlay": _vm.closeOnClickOverlay,
      "message-config": _vm.messageConfig
    },
    on: {
      "buy-clicked": _vm.toBuy
    },
    scopedSlots: _vm._u([{
      key: "sku-actions",
      fn: function(props) {
        return [_c('div', {
          staticClass: "van-sku-actions"
        }, [_c('van-button', {
          attrs: {
            "square": "",
            "size": "large",
            "type": "warning"
          }
        }, [_vm._v("积分兑换")]), _vm._v(" "), _c('van-button', {
          attrs: {
            "square": "",
            "size": "large",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return props.skuEventBus.$emit('sku:buy')
            }
          }
        }, [_vm._v("立即购买")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showSkuPicker),
      callback: function($$v) {
        _vm.showSkuPicker = $$v
      },
      expression: "showSkuPicker"
    }
  })], 1), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": _vm.onShareCancel
    }
  }, [_vm._m(5)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dian-right"
  }, [_vm._v("\n      去逛逛\n      "), _c('img', {
    staticClass: "icon-right-tip",
    attrs: {
      "src": require("../../../assets/images/icon-right.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tuan-rule-box border-top"
  }, [_c('div', {
    staticClass: "flex-between tuan-rule-head"
  }, [_c('div', {
    staticClass: "tuan-rule-text"
  }, [_vm._v("拼团规则")])]), _vm._v(" "), _c('div', {
    staticClass: "tuan-nav gray-light"
  }, [_c('div', {
    staticClass: "tuan-nav-imgo"
  }, [_c('div', {
    staticClass: "tuan-img-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/newImg/icon-tuan-step-1.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("发起或者参团")])]), _vm._v(" "), _c('div', {
    staticClass: "tuan-nav-imgt"
  }, [_c('div', {
    staticClass: "tuan-img-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/newImg/icon-tuan-step-2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("邀请好友参团")])]), _vm._v(" "), _c('div', {
    staticClass: "tuan-nav-imgth"
  }, [_c('div', {
    staticClass: "tuan-img-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/newImg/icon-jielong-step-4.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("人满成团")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-between tuan-rule-head"
  }, [_c('div', {
    staticClass: "tuan-rule-text"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('div', {
    staticClass: "tuan-rule-detail gray-light"
  }, [_c('img', {
    staticClass: "icon-right",
    attrs: {
      "src": require("../../../assets/images/icon-right.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips-text"
  }, [_c('div', [_vm._v("有效期：2019-01-18至2019-12-31")]), _vm._v(" "), _c('div', [_vm._v("除外日期：春节、圣诞节不可用")]), _vm._v(" "), _c('div', [_vm._v("使用时间：周一至周日 24小时可用")]), _vm._v(" "), _c('div', [_vm._v("规则提醒：需您当日一次性体验完毕所有项目，不再与其他优惠同享")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-title"
  }, [_c('div'), _vm._v(" "), _c('span', [_vm._v("商品详情")]), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3632ce50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/tuan/TuanDetail.vue
// module id = 2304
// module chunks = 0